import React from 'react';
import './AdLoader.css';

function AdLoader({ visible }) {
  if (!visible) return null;

  return (
    <div className="ad-loading-overlay" aria-hidden="true">
      <div className="ad-loader-spinner" />
    </div>
  );
}

export default AdLoader;
